(function (Drupal, $, once) {
  Drupal.behaviors.imageCarousel = {
    attach: function (context) {
      $(function () {
        once('image-carousel', '.paragraph-image__content').forEach(function (element) {
          var splide = new Splide(".splide", {
            type: "fade",
            arrowPath: 'M8.33,20l20-20l3.33,3.33L15,20l16.67,16.67L28.33,40L8.33,20',
          });
          splide.mount();
        });
      });
    },
  };
})(Drupal, jQuery, once);
